/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import { get, isEmpty } from 'lodash';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import Checkbox from 'shared/ui/components/form-components/Checkbox.vue';
import LegalPicker from 'shared/ui/components/form-components/pickers/LegalPicker.vue';
import ExpandableContent from 'shared/ui/components/ExpandableContent.vue';
import WorkspaceCategory from 'shared/ui/components/form-components/WorkspaceCategory.vue';

const __vue_script__ = {
    name: 'ContentHubForm',

    components: { BaseInput, BaseSelect, Checkbox, LegalPicker, ExpandableContent, WorkspaceCategory },

    data() {
        return {
            displayAnonymization: false,
            organizations: [],
            showOrganizationPicker: false,
            serversLocations: [],
            containerApps: [],
            form: {
                name: null,
                organization: {},
                legal_documents: [],
                is_test: false,
                container_app: null,
                servers_location: null
            },
            accordionShowDetails: false
        };
    },

    computed: {
        /** @returns {string} */
        orgName() {
            return get(this, 'form.organization.name');
        },

        /** @returns {boolean} */
        disabledForm() {
            return isEmpty(this.form.organization);
        },

        /** @returns {boolean} */
        canInsertMultipleCategories() {
            return this.isCategoryEnabled && get(this.form, 'organization.workspace_defaults.category_multiselect', false);
        },

        /** @returns {boolean} */
        isCategoryEnabled() {
            return get(this.form, 'organization.workspace_defaults.enable_category', false);
        }
    },

    watch: {
        form: {
            deep: true,
            async handler() {
                this.$emit('data', this.form);
                this.$emit('validity', await this.$refs.form.validate({ silent: true }));
            }
        }
    },

    async created() {
        this.organizations = this.$services.user.getOrgsUserIsAllowedToCreateContentHubFor();

        if (this.organizations.length === 1) {
            // In this scenario the user belongs to one organization only
            this.form.organization = this.organizations[0];
            this.showOrganizationPicker = false;
            this.displayAnonymization = this.form.organization.enable_anonymization;

            await this.initServerLocations();
        } else {
            this.showOrganizationPicker = true;
        }

        // Container apps
        this.containerApps = await this.$services.branding.getAllBrandings();
        this.containerApps.forEach(app => app.label = `${app.springboard_name} (${app.fp_ext_id})`);

        if (this.containerApps.length) {
            this.form.container_app = this.containerApps[0];
        }
    },

    methods: {
        async onOrganizationChange() {
            this.form.legal_documents = [];
            this.form.servers_location = null;

            this.cleanCategories();

            this.displayAnonymization = this.form.organization.enable_anonymization;
            await this.initServerLocations();
        },

        async initServerLocations() {
            const orgName = this.$services.org.getNameFromId(this.form.organization._id);
            const servers = await this.$services.server.getOrgServers(orgName);

            this.serversLocations = Object.entries(servers).map(([key, server]) => ({ label: server, value: key }));

            if (this.serversLocations.length) {
                this.form.servers_location = this.serversLocations[0];
            }
        },

        /**
         * Cleans or remove the categories from the form payload
         */
        cleanCategories() {
            if (this.isCategoryEnabled) {
                if (this.form.hasOwnProperty('category')) {
                    this.form.category = this.canInsertMultipleCategories ? undefined : '';
                }

                if (this.form.hasOwnProperty('categories')) {
                    this.form.categories = this.canInsertMultipleCategories ? [] : undefined;
                }
            } else {
                delete this.form.category;
                delete this.form.categories;
            }
        },

        submit() {
            // Empty submission placeholder
        }
    },
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"content-hub-form",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit.apply(null, arguments)}}},[_c('expandable-content',{attrs:{"is-open":_vm.accordionShowDetails},on:{"toggle":function (open) { return _vm.accordionShowDetails = open; }}},[_c('a',{attrs:{"slot":"toggler"},slot:"toggler"},[_vm._v(_vm._s(_vm.accordionShowDetails ? _vm.$t('content_hubs.form.accordion.show_less') : _vm.$t('content_hubs.form.accordion.show_more')))]),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('h5',[_vm._v(_vm._s(_vm.$t('content_hubs.form.accordion.title')))])]),_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('content_hubs.form.accordion.message')))])])]),_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('content_hubs.form.fieldsets.details')))]),(_vm.showOrganizationPicker)?_c('validation-provider',{staticClass:"organization",attrs:{"rules":"required","slim":true,"name":"organization"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{attrs:{"label":_vm.$t('content_hubs.form.organization'),"placeholder":_vm.$t('content_hubs.form.organization_placeholder'),"name":"organization","validations":"required","options":_vm.organizations,"allow-empty":false,"options-label":"display_name","track-by":"_id","errors":errors},on:{"input":_vm.onOrganizationChange},model:{value:(_vm.form.organization),callback:function ($$v) {_vm.$set(_vm.form, "organization", $$v)},expression:"form.organization"}})]}}],null,false,659432582)}):_vm._e(),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"name"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('content_hubs.form.name'),"type":"text","name":"name","errors":errors,"disabled":_vm.disabledForm},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})]}}])}),(_vm.isCategoryEnabled)?[(_vm.canInsertMultipleCategories)?_c('validation-provider',{attrs:{"slim":true,"name":"categories"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('workspace-category',{attrs:{"organization":_vm.form.organization,"name":"categories","errors":errors},model:{value:(_vm.form.categories),callback:function ($$v) {_vm.$set(_vm.form, "categories", $$v)},expression:"form.categories"}})]}}],null,false,3789675977)}):_c('validation-provider',{attrs:{"slim":true,"name":"category"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('workspace-category',{attrs:{"organization":_vm.form.organization,"name":"category","errors":errors},model:{value:(_vm.form.category),callback:function ($$v) {_vm.$set(_vm.form, "category", $$v)},expression:"form.category"}})]}}],null,false,3693883081)})]:_vm._e(),_c('div',{staticClass:"grouped-controls"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":_vm.$t('field_name.servers_location')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"servers_location",attrs:{"label":_vm.$t('content_hubs.form.servers_location'),"placeholder":_vm.$t('content_hubs.form.servers_location_placeholder'),"name":"servers_location","options":_vm.serversLocations,"track-by":"value","errors":errors,"disabled":_vm.disabledForm},model:{value:(_vm.form.servers_location),callback:function ($$v) {_vm.$set(_vm.form, "servers_location", $$v)},expression:"form.servers_location"}})]}}])})],1)],2),_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('content_hubs.form.fieldsets.privacy')))]),_c('p',[_vm._v(_vm._s(_vm.$t('content_hubs.form.privacy_intro')))]),_c('div',{staticClass:"grouped-controls"},[_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"legal_documents"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('legal-picker',{ref:"legal_documents",attrs:{"org-name":_vm.orgName,"label":_vm.$t('content_hubs.form.legal_documents'),"placeholder":_vm.$t('content_hubs.form.legal_documents_placeholder'),"name":"legal_documents","errors":errors,"disabled":_vm.disabledForm},model:{value:(_vm.form.legal_documents),callback:function ($$v) {_vm.$set(_vm.form, "legal_documents", $$v)},expression:"form.legal_documents"}})]}}])})],1)]),(_vm.containerApps.length !== 1)?_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('content_hubs.form.fieldsets.app')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":_vm.$t('field_name.container_app')},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-select',{ref:"container_app",attrs:{"label":_vm.$t('content_hubs.form.container_app'),"placeholder":_vm.$t('content_hubs.form.container_app_placeholder'),"name":"container_app","options":_vm.containerApps,"track-by":"_id","hint":_vm.$t('content_hubs.form.container_app_hint'),"errors":errors,"disabled":_vm.disabledForm},model:{value:(_vm.form.container_app),callback:function ($$v) {_vm.$set(_vm.form, "container_app", $$v)},expression:"form.container_app"}})]}}],null,false,318953387)})],1):_vm._e(),(_vm.displayAnonymization)?_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.fieldsets.anonymization')))]),_c('div',{staticClass:"alert alert-warning anonymized-alert"},[_vm._v(_vm._s(_vm.$t('wizards.create_workspace.form.anonymization_enabled')))])]):_vm._e()],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "ContentHubForm.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__